import axiosInstance from '../services/AxiosInstance';

export const getFundRequests = (getData) => {
  return axiosInstance.get("merchant-balance-histories/list", {
    params: getData,
  });
};

export const getMercahntFundRequests = (getData) => {
  return axiosInstance.get(`merchant-balance-histories/merchant-funds`, {
    params: getData,
  });
};

export const addFundRequests = (data) => {
  return axiosInstance.post("merchant-balance-histories/create", data);
};

export const getFundRequestsCount = (data) => {
  return axiosInstance.get("merchant-balance-histories/details", {
    params: data,
  });
};

export const updateFundRequests = (id, data) => {
  return axiosInstance.put(`merchant-balance-histories/update/${id}`, data);
};

export const fetchFundRequestsById = async (id) => {
    const response = await axiosInstance.get(`merchant-balance-histories/show/${id}`);
    return response.data;
};
